module.exports = __webpack_public_path__ + "img/img_01.40a1bc0d.jpg";